import { useCallback } from 'react';
import {
  useGetKeyValueSettings,
  useKeyValueSettingsMutation,
  updateCache
} from '~/modules/common/hooks';
import { useMeContext } from '~/modules/me';

export const INSIGHTS_SETTINGS_KEY = 'insights_settings';

export const useInsightsSettings = () => {
  const {
    featureFlags: { isPsaRmpBenchOverallocationEnabled }
  } = useMeContext();

  const { isLoading, keyValueSettings } = useGetKeyValueSettings(
    INSIGHTS_SETTINGS_KEY,
    !isPsaRmpBenchOverallocationEnabled
  );

  return {
    isLoading,
    insightsSettings: keyValueSettings
  };
};

export const usePutInsightsSettings = () => {
  const {
    featureFlags: { isPsaRmpBenchOverallocationEnabled }
  } = useMeContext();

  const [putKeyValueSettings] = useKeyValueSettingsMutation(
    updateCache(INSIGHTS_SETTINGS_KEY)
  );

  const putInsightsSettings = useCallback(
    ({ displayUnit, periodScale }) => {
      putKeyValueSettings({
        variables: {
          input: {
            key: INSIGHTS_SETTINGS_KEY,
            settings: { displayUnit, periodScale }
          }
        }
      });
    },
    [putKeyValueSettings]
  );

  return {
    putInsightsSettings: isPsaRmpBenchOverallocationEnabled
      ? putInsightsSettings
      : null
  };
};
